
import React from "react";
import { format, isToday } from "date-fns";

import Text from "src/components/text";
import Slider from "src/components/slider";
import Button from "src/components/button";

import { CustomField } from "src/types/settings/customFields";

import _ from "lodash";
import styles from "./styles.module.scss";


interface DeleteCustomFieldProps {
  show: boolean;
  onClose: () => void;
  selectedCustomField: CustomField | null;
  deleteCustomField: (id: string, name: string) => void;
  isDeleting: boolean;
}

const DeleteCustomField: React.FC<DeleteCustomFieldProps> = ({
  show,
  onClose,
  selectedCustomField,
  deleteCustomField,
  isDeleting,
}) => {

  const formatDate = (iso: string | number) => {
    return format(new Date(iso), "do MMM yyyy");
  };

  if (!selectedCustomField) return null;

  return (
    <Slider.Dialog width="380" show={show} onClose={onClose}>
      <Slider.Header
        title="deleting"
        message={selectedCustomField.name}
      />
      <Slider.Body>
        <div className={styles.body}>
          <p className={styles.description}>
            Are you sure you would like to delete the selected custom field?
          </p>
          <div className={styles.information}>
            <div className={styles.title}>
              <Text
                text={selectedCustomField.name}
                lines={1}
                className={styles.nameText}
                tooltip={{ placement: "auto" }}
              />
            </div>
            <div className={styles.meta}>
              <span>{_.size(selectedCustomField.options)} list value</span>
              <span>
                last updated: {formatDate(selectedCustomField.modifiedDate)}
              </span>
            </div>
          </div>
        </div>
      </Slider.Body>

      <Slider.Actions>
        <Button
          variant="primary"
          icon="paperflite-tick"
          text={isDeleting ? "Deleting..." : "Confirm"}
          disabled={isDeleting}
          onClick={() =>
            deleteCustomField(selectedCustomField.id, selectedCustomField.name)
          }
        />
        <Button
          variant="secondary"
          text="Cancel"
          onClick={onClose}
          disabled={isDeleting}
        />
      </Slider.Actions>
    </Slider.Dialog>
  );
};

export default DeleteCustomField;